import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    db: { schema: 'nf' },
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // sessionStorage: sessao morre ao fechar a janela/aba.
      
      storage: typeof window !== 'undefined' ? window.sessionStorage : undefined,
    },
  }
);

export const STORAGE_BUCKET = 'nf-documentos';
